import { trans } from '@/lib/calendesk-js-library/prototypes/trans'
import { EmployeeSelectionModeType } from '@/calendesk/models/EmployeeSelectionModeType'

export default () => [
  {
    text: trans('wb_employee_selection_mode_any_person_first'),
    value: EmployeeSelectionModeType.ANY_PERSON_FIRST
  },
  {
    text: trans('wb_employee_selection_mode_specific_only'),
    value: EmployeeSelectionModeType.SPECIFIC_ONLY
  },
  {
    text: trans('wb_employee_selection_mode_auto_assign'),
    value: EmployeeSelectionModeType.AUTO_ASSIGN
  }
]
